import React, { useEffect, useState } from "react"

import Typography from "../../../components/shared/Typography"
import { ScrollRevealItem } from "../../WebsiteBuilderV2/components/shared/ScrollReveal"

const Header = ({ isMobile: serverIsMobile = false }) => {
  // Track if component has mounted (to avoid hydration mismatch)
  const [hasMounted, setHasMounted] = useState(false)
  const [clientIsMobile, setClientIsMobile] = useState(serverIsMobile)

  useEffect(() => {
    setHasMounted(true)
    // After mount, detect actual device type
    if (typeof window !== "undefined") {
      const checkMobile = () => {
        const width = window.innerWidth
        setClientIsMobile(width < 768)
      }
      checkMobile()
      window.addEventListener("resize", checkMobile)
      return () => window.removeEventListener("resize", checkMobile)
    }
  }, [])

  // Use server value during initial render to avoid hydration mismatch
  const isMobile = hasMounted ? clientIsMobile : serverIsMobile

  return (
    <header
      className={`flex items-center justify-between border-b border-transparent bg-transparent ${
        isMobile ? "min-h-[72px] px-6 py-3" : "px-8 py-3"
      }`}>
      <ScrollRevealItem entranceDelayMs={140} variant="scaleIn" threshold={0}>
        <a
          href="/"
          className={`landing-header-logo-link ${isMobile ? "flex-1" : "flex items-center"}`}
          style={
            isMobile
              ? {
                  display: "flex",
                  minHeight: "72px",
                  padding: "12px 0",
                  justifyContent: "space-between",
                  alignItems: "center",
                  alignSelf: "stretch"
                }
              : {}
          }>
          <img
            src={isMobile ? "/images/healme_logo.svg" : "/images/healme-top-logo-v2.png"}
            alt="Heal.me"
            className="landing-header-logo h-8 w-auto"
          />
        </a>
      </ScrollRevealItem>
      <div className={`flex items-center ${isMobile ? "gap-8" : "gap-8"}`}>
        <ScrollRevealItem entranceDelayMs={300} variant="fadeUp" threshold={0}>
          <a href="/login" className="landing-header-login-link text-base font-bold text-teal">
            <Typography variant="body" className="font-bold text-teal">
              Login
            </Typography>
          </a>
        </ScrollRevealItem>
        <ScrollRevealItem entranceDelayMs={460} variant="fadeUp" threshold={0}>
          <a
            href="/pro-platform"
            className={`landing-header-join-btn flex items-center justify-center gap-2 rounded-[4px] bg-builder-accent text-white ${
              isMobile ? "px-4 py-1" : "px-6 py-4"
            }`}>
            <Typography variant="body" className="text-base font-bold text-white">
              Join as a practitioner
            </Typography>
          </a>
        </ScrollRevealItem>
      </div>
    </header>
  )
}

export default Header
